module.exports = require('./helpers/bundle-url').getBundleURL('b5eWx') + "logo-dark.eefe0b7f.svg";